module.exports = __webpack_public_path__ + "static/img/j4.d44a7fda.png";